module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "下载小程序连接图片： 小程序链接：必须是已经发布的小程序存在的页面（否则报错） scene最大32个可见字符，只支持数字，大小写英文以及部分特殊字符：!#$&'()*+,/:;=?@-._~，其它字符请自行编码为合法字符",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "选择小程序"
    },
    on: {
      "change": _vm.wxappSelectHandle
    },
    model: {
      value: (_vm.check_wxappid),
      callback: function($$v) {
        _vm.check_wxappid = $$v
      },
      expression: "check_wxappid"
    }
  }, _vm._l((_vm.wx_appid_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "小程序链接"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "小程序链接"
    },
    model: {
      value: (_vm.wx_url),
      callback: function($$v) {
        _vm.wx_url = $$v
      },
      expression: "wx_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序scene"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "小程序scene"
    },
    model: {
      value: (_vm.wx_scen),
      callback: function($$v) {
        _vm.wx_scen = $$v
      },
      expression: "wx_scen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleGetQRcode
    }
  }, [_vm._v("点击下载")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-739e7219", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-739e7219"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/get_qrcode.vue
// module id = 2824
// module chunks = 0